export default __webpack_public_path__ + "static/media/step_012.fc5e64a8.jpeg";